module.exports = __webpack_public_path__ + "static/EDM-e6e6b500139dc7d06feadb7eac3ad1e7.png";